import React from 'react';

export interface IContext {
  (rule: string, location?: number): boolean;
}

export const NotProvided = Symbol('ContextNotProvided');
export type TNotProvided = typeof NotProvided;

const PermissionsContext = React.createContext<TNotProvided | IContext>(NotProvided);

PermissionsContext.displayName = 'PermissionsContext';

export default PermissionsContext;
